import Cookies from "universal-cookie";
import { getPythonApiAsyn } from "../../PostAPI";
import { handleAPIError, APIError } from "../../common/errorHandler";
import { getDecoratedUrl } from "../../common/urlService";
import { API_URL } from "../../../constants/urlConstants";

const cookies = new Cookies();

const getFetchCountryUrl = (payload) => {
  return getDecoratedUrl({ url: API_URL.COUNTRY.FETCH_COUNTRY, payload });
};

export const fetchCountries = async (payload) => {
  // const url = getFetchCountryUrl(payload);
  const url = API_URL.COUNTRY.FETCH_COUNTRY;
  try {
    let result = await getPythonApiAsyn(url, cookies.get("authorization"));
    if (result?.error) {
      throw new APIError(result);
    }
    let res = result;
    res = res.map(item => ({
      label: item.value,
      value: item.key
    }));
    return { content: res };
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};
